import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserPageTitle } from '../shared/constants/browser-page-title.enum';
import { NewSearchPage } from '@app/new-search/new-search.page';
import { PATHS } from '@shared/constants/paths';

const routes: Routes = [
  {
    path: '',
    component: NewSearchPage,
    data: { title: BrowserPageTitle.newSearch },
  },
  {
    path: 'substitutes',
    loadChildren: () =>
      import('./pages/substitutes/substitutes.module').then(
        m => m.SubstitutesPageModule,
      ),
    data: { title: BrowserPageTitle.searchForSub },
  },
  {
    path: 'product-listing',
    loadChildren: () =>
      import('./pages/product-listing/product-listing.module').then(
        m => m.ProductListingPageModule,
      ),
    data: { title: BrowserPageTitle.productListing },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewSearchRoutingModule {}
